import api from '#config/api';

export const signIn = user => api.post('/adelphi/sign_in', user);

export const getCurrentUser = () => api.get('/me');
